import { createAction, props } from '@ngrx/store';

export const updateRefundRequestIsLoadingFromRefundData = createAction(
  '[RefundData] Update RefundRequest Is Loading',
  props<{ isLoading: boolean }>()
);